module.exports = __webpack_public_path__ + "img/rightFixed.8f7c4553.png";